import { Injectable, TemplateRef, EventEmitter } from "@angular/core";
import { GrowlerKind } from "@spscommerce/ds-shared";

export interface GrowlerConfig {
    title: string;
    content: TemplateRef<any>;
    kind?: GrowlerKind;
    imgSrc?: string;
    onClose?: () => void;
}

@Injectable()
export class SpsGrowlerService {
    growlers = new Set<GrowlerConfig>();
    change = new EventEmitter<void>();

    createGrowler(config: GrowlerConfig) {
        this.growlers.add(config);
        this.change.emit();
        return config;
    }

    removeGrowler(config: GrowlerConfig) {
        this.growlers.delete(config);
        this.change.emit();
    }
}
